import React from 'react';
import { motion } from 'framer-motion';
const images = [{
  url: 'https://images.unsplash.com/photo-1546069901-ba9599a7e63c?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
  title: 'Chicken Bowls'
}, {
  url: 'https://images.unsplash.com/photo-1626844131082-256783844137?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
  title: 'Healthy Burgers'
}, {
  url: 'https://images.unsplash.com/photo-1473093295043-cdd812d0e601?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
  title: 'Protein Pasta'
}, {
  url: 'https://images.unsplash.com/photo-1543339308-43e59d6b73a6?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
  title: 'Meal Prep Containers'
}, {
  url: 'https://images.unsplash.com/photo-1604908176997-125f25cc6f3d?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
  title: 'Air Fryer Recipes'
}, {
  url: 'https://images.unsplash.com/photo-1559715745-e1b33a271c8f?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
  title: 'Healthy Desserts'
}];
export function FoodGallery() {
  return <section className="py-24 md:py-28 bg-white" data-id="element-67">
      <div className="container mx-auto px-4" data-id="element-68">
        <div className="text-center mb-16 md:mb-20" data-id="element-69">
          <h2 className="text-3xl md:text-4xl font-black text-darkGreen mb-6 font-montserrat uppercase" data-id="element-70">
            Comida Real,{' '}
            <span className="text-vibrantGreen" data-id="element-71">Resultados Reales</span>
          </h2>
          <p className="text-gray-600 max-w-2xl mx-auto text-lg" data-id="element-72">
            Olvídate de las dietas aburridas. Así se ven las cenas que vas a
            preparar en{' '}
            <strong className="text-darkGreen font-bold" data-id="element-73">15 minutos</strong>.
          </p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-3 gap-4 md:gap-6 max-w-6xl mx-auto" data-id="element-74">
          {images.map((img, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="group relative aspect-square rounded-2xl overflow-hidden shadow-md hover:shadow-xl transition-all duration-300" data-id="element-75">
              <img src={img.url} alt={img.title} className="w-full h-full object-cover transform group-hover:scale-110 transition-transform duration-700" data-id="element-76" />
              <div className="absolute inset-0 bg-gradient-to-t from-darkGreen/80 via-darkGreen/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-end p-4 md:p-6" data-id="element-77">
                <span className="text-white font-bold text-lg md:text-xl font-montserrat tracking-wide" data-id="element-78">
                  {img.title}
                </span>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}